import _extends from "@babel/runtime/helpers/esm/extends";
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import { Checkbox } from '../Checkbox';
import { Radio } from '../Radio';
import { InputField } from '../InputField';
import { FilterRange } from './internal/FilterRange';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function PopoverFilter(props) {
  var filterRangeProps = props.filterRangeProps,
    filterSearchProps = props.filterSearchProps,
    hasPopoverFilterBody = props.hasPopoverFilterBody,
    _props$hidefilterRang = props.hidefilterRange,
    hidefilterRange = _props$hidefilterRang === void 0 ? false : _props$hidefilterRang,
    _props$hidefilterSear = props.hidefilterSearch,
    hidefilterSearch = _props$hidefilterSear === void 0 ? false : _props$hidefilterSear,
    _props$maxHeight = props.maxHeight,
    maxHeight = _props$maxHeight === void 0 ? '200px' : _props$maxHeight,
    _props$minHeight = props.minHeight,
    minHeight = _props$minHeight === void 0 ? 'unset' : _props$minHeight,
    onMenuItemClick = props.onMenuItemClick,
    searchOptions = props.searchOptions,
    selectedItems = props.selectedItems,
    selectionType = props.selectionType;
  var theme = useTheme();
  var filteredOptions = searchOptions == null ? void 0 : searchOptions.filter(function (item) {
    var _item$label;
    if (!(filterSearchProps != null && filterSearchProps.inputValue)) return true;
    return (_item$label = item.label) == null ? void 0 : _item$label.toLowerCase().includes(filterSearchProps.inputValue.toLowerCase());
  });
  return /*#__PURE__*/_jsxs(Box, {
    "data-element": "Box",
    "data-component": "PopoverFilter",
    "data-source-file": "PopoverFilter.tsx",
    children: [filterSearchProps && !hidefilterSearch && /*#__PURE__*/_jsx(InputField, {
      iconLeading: filterSearchProps.iconLeading,
      iconLeadingIcon: filterSearchProps.iconLeadingIcon,
      onChange: function onChange(e) {
        return filterSearchProps.onInputSearch && filterSearchProps.onInputSearch(e);
      },
      placeholder: filterSearchProps.placeholder,
      sx: {
        borderBottom: "1px solid ".concat(theme.palette.gray[200]),
        padding: 4
      },
      value: filterSearchProps.inputValue
    }), filterRangeProps && !hidefilterRange && /*#__PURE__*/_jsx(FilterRange, _extends({}, filterRangeProps)), /*#__PURE__*/_jsx(List, {
      sx: {
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        maxHeight: {
          maxHeight: maxHeight
        },
        minHeight: {
          minHeight: minHeight
        },
        overflow: 'auto',
        padding: !hasPopoverFilterBody ? 4 : '16px 16px 0px 16px'
      },
      "data-element": "List",
      "data-source-file": "PopoverFilter.tsx",
      children: filteredOptions.map(function (item) {
        var selected = Array.isArray(selectedItems) ? !!selectedItems.find(function (v) {
          return v.label === item.label;
        }) : selectedItems.label === item.label;
        return selectionType === 'multi-select' ? /*#__PURE__*/_jsx(Checkbox, _extends({
          checked: selected,
          onChange: function onChange(e) {
            return item && onMenuItemClick(e, item);
          }
        }, item), item.label) : /*#__PURE__*/_jsx(Radio, _extends({
          checked: selected,
          onChange: function onChange(e) {
            return item && onMenuItemClick(e, item);
          }
        }, item), item.label);
      })
    })]
  });
}